import script from "./DialogsTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./DialogsTab.vue?vue&type=script&lang=ts&setup=true"

import "./DialogsTab.vue?vue&type=style&index=0&id=dc5dd2b4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc5dd2b4"]])

export default __exports__